import { SearchFormControlName } from '../enums';

// eslint-disable-next-line import/prefer-default-export
export const SEARCH_DEFAULT_VALUES = {
  [SearchFormControlName.Address]: {},
};
